<template>
  <pt-pt-feedback-table class="pt-pt-feedback-table__page"></pt-pt-feedback-table>
</template>

<script>
import PtPtFeedbackTable from 'cps/other-service/pt-feedback-manage/pt-pt-feedback-table/withData'
export default {
  name: 'pt-pt-feedback-table__view',
  components: {
    'pt-pt-feedback-table': PtPtFeedbackTable
  }
}
</script>
